import { styled } from '@mui/material';
import { ReactComponent as IconCapa } from '../../../assets/images/capa.svg';

export const StyledIconCapa = styled(IconCapa)(() => ({
  cursor: 'pointer',
  height: '22px',
  width: '22px',
  color: 'currentColor',
}));
